import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import translationFallback from '../i18n/en-US/translation.json';
import { Loader } from '../loader';
import { Text } from '../text';
import { loaderStyle, loaderTextStyle, loaderWrapperStyle } from './styles';
function ButtonLoader({ isIconOnly, size, themedStyle }) {
    const { ready, t } = useTranslation();
    const label = ready ? t('Loader.label') : translationFallback.Loader.label;
    return (_jsxs("span", Object.assign({ css: loaderWrapperStyle({ hasLoadingLabel: !isIconOnly, size }) }, { children: [_jsx(Loader, { "aria-label": label, css: loaderStyle({ themedStyle }), variant: "spinner", width: size === 'small' ? 14 : 16 }), !isIconOnly && (_jsxs(Text, Object.assign({ "aria-hidden": "true", css: loaderTextStyle({ themedStyle }) }, { children: [label, "\u2026"] })))] })));
}
export default ButtonLoader;
